var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "launch",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "launch-main main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "launch-con"
  }, [_c('p-token-from')], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };